// extracted by mini-css-extract-plugin
module.exports = {"donateButton":"DonateButton_donateButton__JYbjh","loading":"DonateButton_loading__iNjSl","loader":"DonateButton_loader__Equ24","spin":"DonateButton_spin__BwT3p"};